const DAY_MS = 24 * 60 * 60 * 1000

/**
 * Over hoeveel dagen het openstaande meetmoment de deur uit moet.
 *
 * Negatief betekent dat het al had gemoeten; `null` betekent dat we het niet
 * weten. Die derde uitkomst is het punt: een verzonnen datum is erger dan geen
 * datum, dus zonder eigen tussentijd of zonder ankerpunt komt er niets uit.
 *
 * Twee regels, in deze volgorde:
 * 1. Heeft de rij een vaste datum (`dueAtMs` — de laatste meting van een
 *    huishouden, zes weken na afronding), dan telt die.
 * 2. Anders alleen bij `reason === 'time'`: de afgeleide tussentijd van het
 *    onderzoek minus wat er al verstreken is. Bij een huishouden waarvan het
 *    traject nog loopt (of waarvan de afronding nooit is vastgelegd) mag die
 *    tussentijd níét invallen — daar geldt de zes-wekenregel en die is nog
 *    niet begonnen.
 *
 * AI-CONTEXT: See docs/features/meetmoment-signalering.md
 *
 * @param {import('./buildMeasurementSignals').MeasurementSignalRow|null|undefined} row
 * @param {number} [now] - Nu, in milliseconden
 * @returns {number|null} Hele dagen, of `null` als het niet te zeggen is
 */
const daysUntilDue = (row, now = Date.now()) => {
    if (!row || !row.next) return null

    if (typeof row.dueAtMs === 'number' && Number.isFinite(row.dueAtMs)) {
        return Math.round((row.dueAtMs - now) / DAY_MS)
    }

    if (row.reason !== 'time') return null
    if (typeof row.openDays !== 'number' || typeof row.intervalDays !== 'number') return null

    return row.intervalDays - row.openDays
}

export default daysUntilDue
